// Custom hooks for commodity-related API calls
import { useQuery } from '@tanstack/react-query';
import { getCommodities } from '../api';

const EMPTY_COMMODITIES = Object.freeze({ Fruits: [], Vegetables: [] });

/**
 * Custom hook to fetch commodities using react-query
 * @returns {Object} - { commodities, isLoading, isError, error, refetch }
 */
export const useCommodities = () => {
  const {
    data,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery({
    queryKey: ['commodities'],
    queryFn: () => getCommodities(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
  });

  // Transform the API response to the expected format
  // API returns { response: { Fruits: [...], Vegetables: [...] } }
  // Use a stable empty fallback so consumers don't re-render forever on `data || {}`.
  const commodities = data ?? EMPTY_COMMODITIES;

  return {
    commodities,
    isLoading,
    isError,
    error,
    refetch,
  };
};

